<ng-container *ngTemplateOutlet="(selectedDeliveryType$ | async) === deliveryType.Delivery ? delivery : pickup"></ng-container>

<ng-template #pickup>
  <div class="resto-select l-wrapper-push">
    <app-resto-select></app-resto-select>
  </div>
</ng-template>

<ng-template #delivery>
  <ng-container *ngIf="addressFieldSettings$ | async as addressFieldSettings">
    <ng-container *ngIf="!addressFieldSettings.useAddressFormatType">
      <app-full-address-step [isFullView]="isFullView" [formControl]="form" *ngIf="!addressFieldSettings.usesIndexSearch"></app-full-address-step>
      <app-index-address-step [formControl]="form" *ngIf="addressFieldSettings.usesIndexSearch"></app-index-address-step>
    </ng-container>

    <app-hint-address-step [isFullView]="isFullView" [formControl]="form" *ngIf="addressFieldSettings.useAddressFormatType"></app-hint-address-step>
  </ng-container>
</ng-template>
